<template>
  <div>
    <PriceBar />
    <nuxt />
    <BikeAddModal />
    <EditBikeModal />
    <CongratsModal />
    <BuildBadge />
  </div>
</template>

<script>
/* eslint-disable no-console */
import PriceBar from '@/components/quote/PriceBar'
import BikeAddModal from '@/components/modals/BikeAdd'
import EditBikeModal from '@/components/modals/EditBike'
import CongratsModal from '@/components/modals/Congrats'
import BuildBadge from '@/components/common/BuildBadge'

import { buildSeoHead } from '@/helpers/seo'

export default {
  components: {
    BuildBadge,
    PriceBar,
    BikeAddModal,
    EditBikeModal,
    CongratsModal,
  },
  head() {
    return {
      bodyAttrs: {
        class: 'quote-process-layout',
      },
      style: [
        { cssText: this.$store.getters['theme/theme'], type: 'text/css' },
      ],
      // Canonical + noindex for every page using this layout — see
      // helpers/seo.js.
      ...buildSeoHead(this.$route.path),
    }
  },
  mounted() {
    this.$store.dispatch('quote/setMtaFlag', false)
  },
}
</script>

<style lang="scss">
.ps-hero-body {
  display: table;
  margin: 0 auto;
  width: 100%;
  @include mobile {
    padding: 0 15px;
  }
  @include tablet {
    padding: 0 50px;
  }
  @include desktop {
    padding: 0 100px;
  }
  .container {
    display: table-cell;
    vertical-align: middle;
  }
  @include tablet {
    height: 90vh;
  }
}
.quote-process-layout {
  #launcher {
    display: none;
  }
}
</style>
